import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import VueAxios from 'vue-axios';
import VueMq from 'vue-mq';
import VueCurrencyFilter from 'vue-currency-filter';
import App from './App.vue';
import router from './router';
import './plugins/element';
import '@/assets/global.scss';

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);

Vue.use(VueMq, {
  breakpoints: {
    xs: 768,
    sm: 992,
    md: 1200,
    lg: 1920,
    xl: Infinity,
  },
});

Vue.use(VueCurrencyFilter,
  {
    symbol: '$',
    thousandsSeparator: ',',
    fractionCount: 0,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: true,
  });

Vue.filter('moment', (value, format) => {
  if (value === null || value === undefined || format === undefined) {
    return '';
  }
  if (format === 'from') {
    return moment(value).fromNow();
  }
  return moment.parseZone(value).add(10, 'h').format(format);
  // return moment(value).format(format);
});

Vue.filter('decimal', (value) => {
  let result = value;
  if (!result) result = 0;
  return result.toFixed(2);
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
